module.exports = __webpack_public_path__ + "img/support.a434cf2a.svg";